/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import Modal from '../../../components/modal/modal.component';
import Card from '../../../components/card.component';
import utils from '../../../utils/utils.functions';
import { ConfigContextUtils } from '../../../context/contextUtils.context';
import functions from '../facturacion.functions';
import pad from 'pad';
import {
    Row,
    Col,
    Alert,
} from 'react-bootstrap';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import table from '../facturacion.table';
import { useHistory } from 'react-router';
import AnularGuia from '../../../components/anular.component';
import notification from '../../../components/notification.component';
import {
    faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DetalleBoleta = ({ boletaId, pageGuide = false, updateBol , btnText = '', isRefresh = false }) => {

  const history = useHistory();
  const { setPreloader } = useContext(ConfigContextUtils);
  const [detalle, setDetalle] = useState(null);
  const [anular, setAnular] = useState(false);
  const [visible, setVisible] = useState(false);

  const toggle = () => {
      setVisible(!visible);
  }

  useEffect(() => {
        if (visible) {
            getDetalleBoleta();
        }
  },[visible]);

  const getDetalleBoleta = () => {
    functions.detalle(boletaId).then((response) => {
        setPreloader(false);
        setDetalle(response.boleta);
    })
  }
  
  const detailguide = () => {
    history.push(`/detalle/${detalle.boleta_guia.uuid}`);
  }
  
  const closedAnular = () => {
    setAnular(!anular);
  }

  const refrescar = () => {
    getDetalleBoleta();
    closedAnular();
    if (isRefresh) {
        updateBol(boletaId);
    }
  }

  const sendBolEmail = () => {
    setPreloader(true);
    functions.mail({ uuid: detalle.uuid }).then((response) => {
        if (response.sending) {
            notification.success('Recibo de pago enviado al cliente.');
        } else {
            notification.warning('Ocurrio un problema intente nuevamente.');
        }
        setPreloader(false);
    })
  }


  return (
    <>
     <div onClick={() => toggle()}  className="btnx btnx-warn icon-table m-1">
            <FontAwesomeIcon icon={faExternalLinkAlt} /> {btnText}
     </div>
    <Modal size="lg" show={visible}>
      <Card>
          { anular ? <div className="disabled-modal"></div> : null }
          {detalle ? 
            <>
                <Row>
                    <Col>
                        <div className="box-title-modal">
                            <h4>DETALLE DEL RECIBO NRO. {pad(4,detalle.id,'0')}</h4>
                        </div>
                    </Col>
                    { !detalle.estado ? 
                        <Col>
                            <div className="content-anulation">
                                <span className="badge badge-danger">ANULADO</span>
                                <div className="d-flex justify-content-between w-100">
                                    <div><b>Fecha:</b> {moment(detalle.fecha_anulacion).format('DD/MM/YYYY')}</div>
                                    <div><b>Anulado por:</b> {detalle.boleta_anulado_por.username}</div>
                                </div>
                                <div><b>Motivo:</b> {detalle.motivo_anulacion}</div>
                            </div>
                        </Col>
                    : null }
                </Row>
                <Row className="mt-2">
                    <Col>
                        <div>
                            <div className="label-text">Cliente</div>
                            <div>{detalle.boleta_cliente.rut}</div>
                            <div>{detalle.boleta_cliente.name.toUpperCase()}</div>
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <div className="label-text">Fecha</div>
                            <div>{moment(detalle.fecha).add(1, 'days').format('DD/MM/YYYY')}</div>
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <div className="label-text">Registrado por</div>
                            <div>{detalle.boleta_gestor.username.toUpperCase()}</div>
                        </div>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <DataTable
                            noHeader={true}
                            customStyles={table.customStyles}
                            columns={table.productos()}
                            data={detalle.boleta_producto}
                            dense={true}
                            noDataComponent={'No existen productos'}
                        />
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <div style={{ fontWeight: 'bold' }}>Forma de pago</div>
                        <DataTable
                            noHeader={true}
                            customStyles={table.customStyles}
                            columns={table.pagos()}
                            data={detalle.boleta_pago}
                            dense={true}
                            noDataComponent={'No existen pagos'}
                        />
                    </Col>
                </Row>
                
                <Row className="mt-2">
                    <Col>
                        <div style={{ fontWeight: 'bold' }}>Documentos asociados</div>
                        <DataTable
                            noHeader={true}
                            customStyles={table.customStyles}
                            columns={table.documentsReferences()}
                            data={detalle.documents_sales}
                            dense={true}
                            noDataComponent={'Este recibo no posee documentos asociados.'}
                        />
                    </Col>
                </Row>

                <Row className="mt-2 mb-2">
                    <Col className="d-flex justify-content-end aligns-items-end">
                        <div>
                            <div className="label-text text-right title-amount">Total</div>
                            <div className="big-text">
                                ${table.calculatePaymentWithDocument(detalle)}
                            </div>
                        </div>
                    </Col>
                </Row>
            
                {detalle.observacion !== "" ?
                <Row>
                    <Col>
                        <div className="observation-detail">
                            <div className="label-text">Observación</div>
                            {detalle.observacion}
                        </div>
                    </Col>
                </Row> : null}
            </>
            : null }
          <div className="d-flex justify-content-between">
            {detalle &&
                detalle.estado ? 
                    <button
                        onClick={() => setAnular(!anular)}
                        type="button"
                        className="btnx btnx-warn mr-2"
                    >
                        Anular
                    </button> : null
            }
            <div className="d-flex flex-row">
            {detalle &&
                detalle.estado ?
                <button
                    onClick={sendBolEmail}
                    type="button"
                    className="btnx btnx-warn mr-2"
                >
                    Re-enviar recibo al cliente
                </button>
            : null}
            <button
                onClick={toggle}
                type="button"
                className="btnx btnx-warn mr-2"
            >
                Cancelar
            </button>
            { detalle && !pageGuide &&
                detalle.boleta_guia ?
                <button
                    onClick={detailguide}
                    type="button"
                    className="btnx btnx-warn mr-2"
                >
                    Guia
                </button> : null
            }
            </div>
          </div>
          {detalle ? 
            <Modal backDrop={false} size={'xl'} show={anular}>
                <Card>
                    <AnularGuia 
                        show={anular}
                        codigo={boletaId}
                        onClose={() => closedAnular()}
                        onConfirm={() => refrescar()}
                        isGuide={detalle.boleta_guia ? true : false}
                    />
                </Card>
            </Modal>
          : null}
      </Card>
    </Modal>
    </>
  )
}

export default DetalleBoleta;